'use client'
import { DevTool } from '@hookform/devtools'
import dynamic from 'next/dynamic'
import React from 'react'
import { Control, type FieldValues } from 'react-hook-form'

interface DevModeProps<T extends FieldValues = FieldValues> {
  control: Control<T>
}

function _FormDebugger<T extends FieldValues = FieldValues>({
  control,
}: DevModeProps<T>) {
  if (process.env.NODE_ENV !== 'development') {
    return null
  }

  return <DevTool control={control} placement="bottom-right" />
}

// Disabling Server Rendering since it is just for development only
const FormDebugger = dynamic(() => Promise.resolve(React.memo(_FormDebugger)), {
  ssr: false,
}) as <T extends FieldValues = FieldValues>(
  props: DevModeProps<T>
) => React.ReactElement | null
export default FormDebugger
